import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-empty-list-item',
	templateUrl: './empty-list-item.component.html',
	styleUrls: ['./empty-list-item.component.scss']
})
export class EmptyListItemComponent {

	@Input()
	message: string;

	constructor() { }

}
